export async function calcularFrete({ cepDestino, items }) {
  try {
    const response = await fetch(
      "https://calcularfrete-2gw7h3kv7q-uc.a.run.app/calcularFrete",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          from: { postal_code: "03012020" },
          to: { postal_code: cepDestino.replace(/\D/g, "") },
          products: items.map((item) => ({
            id: item.productId,
            width: 8,
            height: 6,
            length: 12,
            weight: 0.12,
            insurance_value: 10,
            quantity: item.quantity,
          })),
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Erro ao calcular frete");
    }

    return await response.json();
  } catch (err) {
    console.error("Erro no frete:", err);
    return [];
  }
}